import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

export default function useCountry() {
  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    {
      key: 'id', sortable: false, label: 'STT', thAttr: { width: '7%' },
    },
    {
      key: 'user_fullname', sortable: false, label: 'Người tạo',
    },
    { key: 'content', sortable: false, label: 'Nội dung hoặc Link' },
    { key: 'type_social', sortable: false, label: 'Nền tảng' },
    { key: 'published_at', sortable: false, label: 'Hẹn giờ xuất bản' },
    { key: 'is_published', sortable: false, label: 'Trạng thái' },
    { key: 'message', sortable: false, label: 'Thông báo lỗi' },

    // {
    //   key: 'actions',
    //   label: 'Hành động',
    //   thAttr: { width: 100 },
    //   thClass: 'text-center',
    //   tdClass: 'text-center',
    // },
  ];
  const loading = ref(false);
  const perPage = ref(30);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [30, 50, 100];
  const searchQuery = ref({});
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const positionFilter = ref(null);
  const planFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const itemsData = ref([]);
  const posts = ref([]);
  const loadMore = ref('');

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const fetchAll = () => {
    loading.value = true;
    store
      .dispatch('social/fetchAllListPostWait', {
        keyword: searchQuery.value.keyword,
        channel_id: searchQuery.value.channel_id,
        end_date: searchQuery.value.end_date,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        isPaginate: isPaginate.value,
        status: searchQuery.value.status,
      })
      .then((response) => {
        loading.value = false;
        if (response.status === 200) {
          const items = response.data.data.data;
          const { total } = response.data.data;
          totalEntries.value = total;
          itemsData.value = items;
        }
      });
  };

  const refetchData = () => {
    fetchAll();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const statusOptions = [
    { label: 'Mới tạo', id: 10 },
    { label: 'Đang chờ duyệt', id: 20 },
    { label: 'Đã duyệt', id: 30 },
    { label: 'Từ chối', id: 40 },
  ];
  const resolveStatusVariant = (status) => {
    if (status === 10) return 'secondary';
    if (status === 20) return 'warning';
    if (status === 30) return 'success';
    if (status === 40) return 'danger';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveStatusText = (status) => statusOptions.find((x) => x.id === status).label;

  return {
    loading,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    itemsData,
    fetchAll,
    resolveStatusVariant,
    resolveStatusText,
    refetchData,

    // Extra Filters
    positionFilter,
    planFilter,
    statusFilter,
    statusOptions,
    posts,
    loadMore,
  };
}
